type Props = {
  text: string;
};

export default function FactionBlockLayout({ text }: Props) {
  return (
    <>
      <div
        className="absolute z-2 top-0 left-0 size-full rounded-2xl"
        style={{ background: "rgba(27, 27, 27, 0.94)", backdropFilter: "blur(4px)" }}
      />
      <div className="absolute top-1/2 left-1/2 z-3 text-15 font-bold text-white/70 leading-none uppercase -translate-y-1/2 -translate-x-1/2">
        {text}
      </div>
    </>
  );
}
